export function Row(props){
    return (
        <div className={`row${(props.classe ? ' '+props.classe : '')}`} {...props}>
            {props.children}
        </div>
    )
}